import { render, staticRenderFns } from "./service-org.vue?vue&type=template&id=043814bf&"
import script from "./service-org.vue?vue&type=script&lang=js&"
export * from "./service-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports